import React, { Component } from "react";
import { StyleSheet, View, StatusBar } from "react-native";

import Walkthrough from './WorkThrough/Walkthrough'

export default class TestPage extends Component {

  _onWorkFlowFinished = () => {
    this.props.navigation.navigate('Welcome');
  };
  render() {
    return (
      <View style={styles.container}>

        <Walkthrough onFinished={this._onWorkFlowFinished}/>
 
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "stretch",
  },
});
